import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=8856d1a8&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8856d1a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/run/media/DATA/workspace/DEV/vuejs/company-searcher/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VForm,VTextField})
